"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviourNodeExecution = void 0;
/**
 * Represents behaviour node execution information
 */
var BehaviourNodeExecution = /** @class */ (function (_super) {
    __extends(BehaviourNodeExecution, _super);
    function BehaviourNodeExecution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "BehaviourNodeExecution";
        _this.activityId = function () {
            _this.push(function (_) { return "activityId"; });
        };
        _this.behaviourQualifier = function () {
            _this.push(function (_) { return "behaviourQualifier"; });
        };
        _this.behaviourId = function () {
            _this.push(function (_) { return "behaviourId"; });
        };
        _this.reference = function () {
            _this.push(function (_) { return "reference"; });
        };
        _this.qualifier = function () {
            _this.push(function (_) { return "qualifier"; });
        };
        _this.state = function () {
            _this.push(function (_) { return "state"; });
        };
        _this.type = function () {
            _this.push(function (_) { return "type"; });
        };
        _this.created = function () {
            _this.push(function (_) { return "created"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return BehaviourNodeExecution;
}(Array));
exports.BehaviourNodeExecution = BehaviourNodeExecution;
//# sourceMappingURL=BehaviourNodeExecution.js.map